/**
 * Bridge between the Microlab AI chat and the open Presentation Maker.
 *
 * The chat dispatches `microlab:presentation-design` with the request text;
 * the maker (which owns the slides, autosave and permissions) applies the
 * styling and answers through `respond`. If no maker answers in time the chat
 * falls back to its normal flow.
 */

export const PRESENTATION_DESIGN_EVENT = "microlab:presentation-design";

export { looksLikeDesignRequest } from "../../../canvas/design/designIntent";

export function requestPresentationDesign(text, { timeoutMs = 4000 } = {}) {
  return new Promise((resolve) => {
    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      resolve(value);
    };
    const timer = window.setTimeout(() => finish(null), timeoutMs);
    window.dispatchEvent(
      new CustomEvent(PRESENTATION_DESIGN_EVENT, {
        detail: { text, respond: finish },
      })
    );
  });
}
